const noAdsProperties = [
  '270', // chopchat.com
  '138', // hailwv.com
  '35', // titansized.com
  '54', // ramblinfan.com
  '233', // fightinggobbler.com
  '152', // hoosierstateofmind.com
  '28', // justblogbaby.com
  '56', // dawgpounddaily.com
];

export function shouldBlockAds(property: string): boolean {
  return noAdsProperties.includes(property);
}
